/* eslint-disable */
// 获取当前开发环境
// let service = process.env.NODE_ENV

// 设置api
let api = '/admin/'
let nginx = '/rest/v2/'

export default {
	// 账号模块
	accountList: `${api}account/list`,				// 账号列表 + 搜索
	accountInfo: `${api}account/info/`,				// 账号详情
    accountPlanText: `${api}account/plan-text/`,	// 获取明文账号
	accountThirdList: `${api}account/third-list`,	// 获取账号绑定的第三方账号列表
	accountDelete: `${api}account/delete/`,			// 删除账号
	accountMigrate: `${api}account/migrate`,		// 迁移账号至不同国家
    accountUpType: `${api}account/up-type`,			// 更改账号类型

	// 用户模块
	userList: `${api}user/list`,					// 用户列表 + 用户搜索
	userUpLevel: `${api}user/up-level`,				// 修改用户级别
	userCreate: `${api}user/create`,				// 创建用户
	userInfo: `${api}user/info/`,					// 用户详情
	userOrderList: `${api}user/order-list`,			// 用户订单列表
	userDeviceList: `${api}user/device-list`,		// 用户已绑定设备列表
	userDeviceCloudList: `${api}user/cloud-list`,	// 获取用户设备已开通云存储列表
	userDelete: `${api}user/delete/`,				// 删除用户
	userUploadExcel: `${api}user/upload-excel`,		// excel导入用户

	// 产品管理
	productList: `${api}product/list`,				// 获取产品列表
	productCreate: `${api}product/create`,			// 添加指定产品信息
	productInfo: `${api}product/info/`,				// 获取指定产品详情
	productPackgeList: `${api}product/pack-list/`,	// 获取指定产品关联的套餐列表
	productFuncList: `${api}product/func-list/`,	// 获取指定产品关联的功能列表
	productUpdate: `${api}product/update`,			// 更新指定产品数据
	productUpStatus: `${api}product/up-status`,		// 修改指定产品状态
	productUpSort: `${api}product/up-sort`,			// 修改指定产品状态
	productDelete: `${api}product/delete/`,			// 删除指定产品数据
	productSecret: `${api}product/secret/`,			// 获取指定产品的Secret

	// 产品功能管理
	proFuncList: `${api}pro/func/list`,
	proFuncCreate: `${api}pro/func/create`,
	proFuncInfo: `${api}pro/func/info/`,
	proFuncUpdate: `${api}pro/func/update`,
	proFuncUpStatus: `${api}pro/func/up-status`,
	proFuncDelete: `${api}pro/func/delete/`,

	// 套餐管理
	packList: `${api}pack/list`,
	packCreate: `${api}pack/create`,
	packInfo: `${api}pack/info/`,
	packUpdate: `${api}pack/update`,
	packUpStatus: `${api}pack/up-status`,
	packDelete: `${api}pack/delete/`,

	// 出厂设备管理
	factoryList: `${api}factory/list`,					// 出厂设备列表 + 搜索
	factoryBatchCreate: `${api}factory/batch`,			// 生成出厂设备记录
	factoryBatchUuid: `${api}factory/batch-uuid`,		// 批量生成出厂设备
    factoryImportMac: `${api}factory/import-mac`,		// 上传mac表出厂设备
	factoryRecordList: `${api}factory/record-list`,		// 设备出厂记录列表
	factoryRecordAllow: `${api}factory/record-allow`,	// 修改设备智能出厂允许状态
	factorySecret: `${api}factory/secret/`,				// 查看出厂设备UUID加密信息
	factoryDownExcel: `${api}factory/down-excel`,		// 设备出厂记录列表
	factoryDelete: `${api}factory/delete/`,				// 设备出厂记录列表

	// 已上线设备管理模块
	deviceList: `${api}device/list`,				// 已上线（被用户绑定过）设备列表 + 搜索
	deviceInfo: `${api}device/info`,				// 设备详情
	deviceUserList: `${api}device/user-list`,		// 设备已绑定用户信息列表

	// 大拿设备模块管理
	danaDeviceList: `${api}dana/list`,						// 大拿设备列表 + 搜索
	danaDeviceUpRole: `${api}dana/up-role`,					// 修改单个指定id的设备升级权限
	danaDeviceUpRoles: `${api}dana/up-roles`,				// 修改多个指定id的设备升级权限
	danaDeviceWhereUpRoles: `${api}dana/where-up-roles`,	// 根据条件修改多个设备升级权限
	danaDeviceUploadExcel: `${api}dana/upload-excel`,		// excel导入大拿设备
	danaFacilityList: `${api}dana/facility`,				// 大拿设备列表 + 搜索

	// 工厂SN标识库管理
    snFactoryList: `${api}sn/factory/list`,
    snFactoryCreate: `${api}sn/factory/create`,
    snFactoryUpdate: `${api}sn/factory/update`,
    snFactoryDelete: `${api}sn/factory/delete/`,

	// 产品SN标识库管理
    snProductList: `${api}sn/product/list`,
    snProductCreate: `${api}sn/product/create`,
    snProductInfo: `${api}sn/product/info/`,
    snProductUpdate: `${api}sn/product/update`,
    snProductDelete: `${api}sn/product/delete/`,

	// 版本管理（√）
	versionList: `${api}version/index`,
	versionCreate: `${api}version/create`,
	versionInfo: `${api}version/info`,
	versionUpdate: `${api}version/update`,
	versionUpStatus: `${api}version/up-status`,
	versionDelete: `${api}version/delete/`,

	// APP及型号管理
	appList: `${api}app/list`,				// 获取App列表
	appCreate: `${api}app/create`,			// 添加指定App信息
	appInfo: `${api}app/info/`,				// 获取指定App详情
	appSecret: `${api}app/secret/`,			// 获取指定App的Secret
	appUpdate: `${api}app/update`,			// 更新指定App数据
	appDelete: `${api}app/delete/`,			// 删除指定App数据

	// App极光配置管理
	jpushList: `${api}app/jpush/list`,				// 获取App极光配置列表
	jpushCreate: `${api}app/jpush/create`,			// 添加指定App极光配置信息
	jpushInfo: `${api}app/jpush/info/`,				// 获取指定App极光配置详情
	jpushUpdate: `${api}app/jpush/update`,			// 更新指定App极光配置数据
	jpushDelete: `${api}app/jpush/delete/`,			// 删除指定App极光配置数据

	// App极光配置管理
	fcmList: `${api}app/fcm/list`,					// 获取App的FCM配置列表
	fcmCreate: `${api}app/fcm/create`,				// 添加指定App的FCM配置信息
	fcmInfo: `${api}app/fcm/info/`,					// 获取指定App的FCM配置详情
	fcmUpdate: `${api}app/fcm/update`,				// 更新指定App的FCM配置数据
	fcmDelete: `${api}app/fcm/delete/`,				// 删除指定App的FCM配置数据

	// App极光配置管理
	apnsList: `${api}app/apns/list`,				// 获取App的FCM配置列表
	apnsCreate: `${api}app/apns/create`,			// 添加指定App的FCM配置信息
	apnsInfo: `${api}app/apns/info/`,				// 获取指定App的FCM配置详情
	apnsUpdate: `${api}app/apns/update`,			// 更新指定App的FCM配置数据
	apnsDelete: `${api}app/apns/delete/`,			// 删除指定App的FCM配置数据

	// App个推配置管理
	getuiList: `${api}app/getui/list`,				// 获取App的个推配置列表
	getuiCreate: `${api}app/getui/create`,			// 添加指定App的个推配置信息
	getuiInfo: `${api}app/getui/info/`,				// 获取指定App的个推配置详情
	getuiUpdate: `${api}app/getui/update`,			// 更新指定App的个推配置数据
	getuiDelete: `${api}app/getui/delete/`,			// 删除指定App的个推配置数据

	// App友盟推送配置管理
	upushList: `${api}app/upush/list`,				// 获取App友盟推送配置列表
	upushCreate: `${api}app/upush/create`,			// 添加指定App友盟推送配置信息
	upushInfo: `${api}app/upush/info/`,				// 获取指定App友盟推送配置详情
	upushUpdate: `${api}app/upush/update`,			// 更新指定App友盟推送配置数据
	upushDelete: `${api}app/upush/delete/`,			// 删除指定App友盟推送配置数据

	// 订单管理
	orderList: `${api}order/list`,
	orderInfo: `${api}order/info/`,
	orderCount: `${api}order/count`,
	orderMap: `${api}order/map`,
	orderLoad: `${api}order/load`,

	// 消息管理
	msgList: `${api}msg/list`,
	msgDeviceList: `${api}msg/dev-list`,
	msgDeviceFile: `${api}msg/dev-file/`,

	// 分享管理
	shareList: `${api}share/list`,

	// 日志管理
	logList: `${api}log/list`,
	logInfo: `${api}log/info/`,
	logMongoList: `${api}log/mongo-list`,

	// 统计模块
	statisticsUser: `${api}statistics/user`,				// 用户地图分布统计
	statisticsDevice: `${api}statistics/device`,			// 设备地图分布统计
	statisticsNum: `${api}statistics/num`,					// 获取统计数据
	statisticsRetain: `${api}statistics/retain`,			// 用户留存率/流失率统计
	statisticsDayCount: `${api}statistics/day-count`,		// 统计指定日期app启动次数范围内的用户数

	// 统计数据
	appOpenList: `${api}statistics/app-open`,				// 获取用户打开APP的时间记录列表
	numStatisticsList: `${api}statistics/num-list`,			// 获取统计数据列表

	// 获取销售统计数据
	statisticsSale: `${api}sale/statistics`,				// 获取用户打开APP的时间记录列表
	saleUploadExcel: `${api}sale/import`,					// excel导入销售数据
	saleList: `${api}sale/list`,							// 获取销售数据列表

	// 反馈类型管理
	feedbackTypeList: `${api}feedback/type/index`,		// 获取反馈类型列表
	feedbackTypeCreate: `${api}feedback/type/create`,	// 添加反馈类型数据
	feedbackTypeInfo: `${api}feedback/type/info/`,		// 获取指定反馈类别详情
	feedbackTypeUpdate: `${api}feedback/type/update`,	// 修改反馈类别数据
	feedbackTypeUpSort: `${api}feedback/type/up-sort`,	// 修改反馈类别序号
	feedbackTypeDelete: `${api}feedback/type/delete/`,	// 删除反馈类别数据

	// 用户反馈消息管理
	feedbackList: `${api}feedback/list`,				// 获取反馈消息列表
	feedbackInfo: `${api}feedback/info/`,				// 获取指定反馈消息详情
	feedbackUpStatus: `${api}feedback/up-status`,		// 修改指定反馈消息状态

	// 后台菜单管理模块
	menuList: `${api}menu/list`,					// 菜单列表
	menuInfo: `${api}menu/info/`,					// 菜单详情
	menuCreate: `${api}menu/add`,					// 创建菜单
	menuUpdate: `${api}menu/up`,					// 修改菜单
	menuUpSort: `${api}menu/sort`,					// 修改菜单排序
	menuDelete: `${api}menu/del/`,					// 删除菜单
	menuFunc: `${api}menu/menu-func`,				// 获取菜单及菜单下的功能列表

	// 后台功能管理模块
	funcList: `${api}func/list`,					// 功能列表
	funcInfo: `${api}func/info/`,					// 功能详情
	funcCreate: `${api}func/add`,					// 创建功能
	funcUpdate: `${api}func/up`,					// 修改功能
	funcUpSort: `${api}func/sort`,					// 修改功能排序
	funcUpRoute: `${api}func/route`,				// 修改功能路由地址
	funcDelete: `${api}func/del/`,					// 删除功能

	// 后台角色管理模块
	roleList: `${api}role/list`,					// 角色列表
	roleInfo: `${api}role/info/`,					// 角色详情
	roleCreate: `${api}role/add`,					// 创建角色
	roleUpdate: `${api}role/up`,					// 修改角色
	roleDelete: `${api}role/del/`,					// 删除角色

	// 后台管理员管理模块
	adminerList: `${api}admin/list`,				// 管理员列表
	adminerInfo: `${api}admin/info/`,				// 管理员详情
	adminerCreate: `${api}admin/add`,				// 创建管理员
	adminerUpdate: `${api}admin/up`,				// 修改管理员
	adminerDelete: `${api}admin/del/`,				// 删除管理员
	adminerDisable: `${api}admin/disable`,			// 禁用管理员
	adminerLifeban: `${api}admin/lifeban/`,			// 解除管理员禁用状态
	adminerOwnerInfo: `${api}admin/owninfo/`,		// 后台管理员获取自己的信息
	adminerOwnerUpdate: `${api}admin/ownup`,		// 后台管理员修改自己的信息
	adminerResetPwd: `${api}admin/reset-pwd`,		// 重置管理员密码

	// 后台管理员登录、注销
	adminLogin: `${api}admin/login`,				// 管理员登录
	adminVerifyCode: `${api}admin/code`,			// 获取登录验证码
	adminLogout: `${api}admin/logout`,				// 注销登录

	// 获取后台日志列表
	adminLogList: `${api}admin/log`,				// 获取后台日志列表

	// 文件管理
	fileList: `${api}file/list`,					// 获取文件列表
	fileInfo: `${api}file/info/`,					// 获取文件详情
	fileDelete: `${api}file/delete/`,				// 删除文件
	fileCertCreate: `${api}file/cert/create`,		// 上传证书文件
	fileCertUpdate: `${api}file/cert/update`,		// 修改证书文件

	// s3文件操作
	s3DownPreSign: `${api}file/s3/down-preSign`,	// 获取s3文件预签名

	// 服务器管理
	serverBaseList: `${api}server/base/list`,				// 获取服务器基础配置列表
	serverBaseInfo: `${api}server/base/info/`,				// 服务器基础配置详情
	serverBaseCreate: `${api}server/base/create`,			// 创建服务器基础配置
	serverBaseUpdate: `${api}server/base/update`,			// 修改服务器基础配置
	serverBaseDelete: `${api}server/base/delete/`,			// 删除服务器基础配置
	serverBaseSync: `${api}server/base/sync`,				// 同步全球数据中心数据
	serverAccountList: `${api}server/account/list`,			// 获取服务器基础配置列表
	serverAccountInfo: `${api}server/account/info/`,		// 服务器基础配置详情
	serverAccountCreate: `${api}server/account/create`,		// 创建服务器基础配置
	serverAccountUpdate: `${api}server/account/update`,		// 修改服务器基础配置
	serverAccountDelete: `${api}server/account/delete/`,	// 删除服务器基础配置

	// 国家数据管理
	countryList: `${api}country/list`,				// 获取国家数据列表
	countryInfo: `${api}country/info/`,				// 国家数据详情
	countryCreate: `${api}country/create`,			// 创建国家数据
	countryUpdate: `${api}country/update`,			// 修改国家数据
	countryDelete: `${api}country/delete/`,			// 删除国家数据

	// 数据同步管理
	dataSyncList: `${api}sync/list`,				// 获取数据同步记录列表
	dataSyncInfo: `${api}sync/info/`,				// 数据同步记录详情
	dataSyncRetry: `${api}sync/retry`,				// 重新同步失败数据
	dataSyncDelete: `${api}sync/delete/`,			// 删除同步数据

	// 同步数据类型
	syncTypeList: `${api}sync/type/list`,			// 获取同步数据类型列表
	syncTypeCreate: `${api}sync/type/create`,		// 添加同步数据类型
	syncTypeUpdate: `${api}sync/type/update`,		// 修改同步数据类型
	syncTypeDelete: `${api}sync/type/delete/`,		// 删除同步数据类型

	// 友情链接数据管理
	linkList: `${api}link/list`,				// 获取国家数据列表
	linkInfo: `${api}link/info`,				// 国家数据详情
	linkCreate: `${api}link/create`,			// 创建国家数据
	linkDelete: `${api}link/delete`,			// 删除国家数据
	
	// 后台版本日志管理模块
	adminVersionList: `${api}version/admin/list`,		// 版本日志列表
	adminVersionInfo: `${api}version/admin/info/`,		// 版本日志详情
	adminVersionCreate: `${api}version/admin/create`,	// 创建版本日志
	adminVersionUpdate: `${api}version/admin/update`,	// 修改版本日志
	adminVersionDelete: `${api}version/admin/delete/`,	// 删除版本日志

	// 云存储服务接口
	cloudVideoInfo: `${nginx}filelist_get`,			// 获取s3云存储信息列表
	nginxAwsSigined: `${nginx}packput_presignurl`,	// s3上传文件生成预签名

}



// WEBPACK FOOTER //
// ./src/axios/url.js